(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(element) {
      this.slider = element;
      this.slides = this.slider.querySelectorAll('.hero-slider__slide');
      this.dots = this.slider.querySelectorAll('.hero-slider__dot');
      this.prevButton = this.slider.querySelector('.hero-slider__arrow--prev');
      this.nextButton = this.slider.querySelector('.hero-slider__arrow--next');
      this.currentIndex = 0;
      this.autoplayInterval = null;

      if (this.slides.length > 0) {
        this.init();
      }
    }

    init() {
      this.slides[0].classList.add('active');
      
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Auto-play every 5 seconds
      this.startAutoplay();

      // Pause autoplay on hover
      this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
      this.slider.addEventListener('mouseleave', () => this.startAutoplay());
    }

    goToSlide(index) {
      this.slides[this.currentIndex].classList.remove('active');
      this.dots[this.currentIndex]?.classList.remove('hero-slider__dot--active');
      
      this.currentIndex = index;
      
      this.slides[this.currentIndex].classList.add('active');
      this.dots[this.currentIndex]?.classList.add('hero-slider__dot--active');
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      if (this.slides.length > 1) {
        this.autoplayInterval = setInterval(() => this.next(), 5000);
      }
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.hero-slider');
    sliders.forEach(slider => new HeroSlider(slider));
  });

  } catch(e) { console.error(e); }
})();
})();
